import clsx from 'clsx';
import {ReactNode} from 'react';
import {useLocation} from 'react-router-dom';

interface Props {
  name: ReactNode;
  poster?: ReactNode;
  description?: ReactNode;
  right?: ReactNode;
  children?: ReactNode;
  className?: string;
}
export function TitlePageHeaderLayout({
  name,
  description,
  children,
  right,
  poster,
  className,
}: Props) {
  const pathname = useLocation().pathname;

  return (
    <div
      className={clsx(
        'absolute bottom-0 right-0 z-20 w-full items-end justify-between gap-24 md:h-[270px] lg:flex',
        className,
        pathname.includes('people') && '!static !h-auto md:!h-auto',
      )}
      style={{
        background:
          'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.90) 67.81%, #000 100%)',
      }}
    >
      <div
        className={clsx(
          'container flex flex-col items-end lg:flex-row',
          pathname.includes('people') && '!px-0 !pl-0 !pr-0',
        )}
      >
        {poster}
        <div className="flex-auto max-sm:ml-auto">
          {children}
          <h1 className="mb-12 text-xl md:mb-10 md:text-5xl">{name}</h1>
          {description && (
            <div className="text-base font-normal">{description}</div>
          )}
        </div>
        {right}
      </div>
    </div>
  );
}
